import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bab9968"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "uf-approvalDetail"
}
const _hoisted_2 = { class: "uf-approvalDetail__header" }
const _hoisted_3 = { class: "uf-approvalDetail__process" }
const _hoisted_4 = { class: "uf-approvalDetail__process-date" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "uf-approvalDetail__process-i",
  style: {"margin-right":"5px"}
}, [
  /*#__PURE__*/_createElementVNode("i"),
  /*#__PURE__*/_createElementVNode("b")
], -1))
const _hoisted_6 = { class: "uf-approvalDetail__process-value" }
const _hoisted_7 = {
  key: 0,
  style: {"margin-right":"5px"}
}
const _hoisted_8 = { class: "uf-approvalDetail__info" }
const _hoisted_9 = { class: "uf-approvalDetail__info__title" }
const _hoisted_10 = {
  class: "uf-approvalDetail__info__content",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_11 = { class: "uf-approvalDetail__info__footer" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__title" }, "报警内容", -1))
const _hoisted_13 = { class: "uf-events__close" }
const _hoisted_14 = { class: "uf-events__close-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "部件编码：", -1))
const _hoisted_16 = { class: "uf-events__close-content" }
const _hoisted_17 = { class: "uf-events__close-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "部件名称：", -1))
const _hoisted_19 = {
  class: "uf-events__close-content",
  style: {"color":"#FF5B34"}
}
const _hoisted_20 = { class: "uf-events__close-item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "部件类型：", -1))
const _hoisted_22 = { class: "uf-events__close-content" }
const _hoisted_23 = { class: "uf-events__close-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "部件位置：", -1))
const _hoisted_25 = { class: "uf-events__close-content" }
const _hoisted_26 = { class: "uf-events__title" }
const _hoisted_27 = {
  class: "uf-copy uf-events__close",
  style: {"border":"none"}
}
const _hoisted_28 = {
  key: 0,
  class: "uf-copy__item"
}
const _hoisted_29 = { class: "uf-events__close-item" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "部件编码：", -1))
const _hoisted_31 = { class: "uf-events__close-content" }
const _hoisted_32 = { class: "uf-events__close-item" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "故障类型：", -1))
const _hoisted_34 = { class: "uf-events__close-content" }
const _hoisted_35 = { class: "uf-events__close-item" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "部件位置：", -1))
const _hoisted_37 = { class: "uf-events__close-content" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__title" }, "处理信息", -1))
const _hoisted_39 = { class: "uf-events__close" }
const _hoisted_40 = { class: "uf-events__close-item" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "处理人：", -1))
const _hoisted_42 = {
  class: "uf-events__close-content",
  style: {"color":"#3d6eeb"}
}
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { class: "uf-events__close-item" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "领取时间：", -1))
const _hoisted_46 = { class: "uf-events__close-content" }
const _hoisted_47 = { class: "uf-events__close-item" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "领取耗时：", -1))
const _hoisted_49 = { class: "uf-events__close-content" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "操作：")
], -1))
const _hoisted_51 = { class: "operation-list" }
const _hoisted_52 = { class: "operation-list__item-title" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { class: "item-content__content" }
const _hoisted_55 = { class: "item-content__content-code" }
const _hoisted_56 = { class: "item-content__content-name" }
const _hoisted_57 = { class: "operation-list__item-title" }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = { class: "item-content__content" }
const _hoisted_60 = { class: "item-content__content-code" }
const _hoisted_61 = { class: "item-content__content-name" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__title" }, "关闭信息", -1))
const _hoisted_63 = { class: "uf-events__close" }
const _hoisted_64 = { class: "uf-events__close-item" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "关闭时间：", -1))
const _hoisted_66 = { class: "uf-events__close-content" }
const _hoisted_67 = { class: "uf-events__close-item" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "处理时长：", -1))
const _hoisted_69 = { class: "uf-events__close-content" }
const _hoisted_70 = { class: "uf-events__close-item" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "处理结果：", -1))
const _hoisted_72 = { class: "uf-events__close-content" }
const _hoisted_73 = {
  key: 0,
  class: "uf-events__close-item"
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "火灾报警控制器：", -1))
const _hoisted_75 = { class: "uf-events__close-content" }
const _hoisted_76 = {
  key: 1,
  class: "uf-events__close-item"
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "消防联动控制器：", -1))
const _hoisted_78 = { class: "uf-events__close-content" }
const _hoisted_79 = {
  key: 2,
  class: "uf-events__close-item"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "图片：", -1))
const _hoisted_81 = { class: "uf-events__close-content" }
const _hoisted_82 = { class: "uf-events__close-item" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "备 注：", -1))
const _hoisted_84 = { class: "uf-events__close-content" }
const _hoisted_85 = {
  key: 4,
  class: "uf-copy uf-events__close"
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-copy__title" }, "抄送人备注", -1))
const _hoisted_87 = { class: "uf-events__close-item" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "备注人：", -1))
const _hoisted_89 = { class: "uf-events__close-content" }
const _hoisted_90 = { class: "uf-events__close-item" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "备注时间：", -1))
const _hoisted_92 = { class: "uf-events__close-content" }
const _hoisted_93 = { class: "uf-events__close-item" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "备注结果：", -1))
const _hoisted_95 = { class: "uf-events__close-content" }
const _hoisted_96 = {
  key: 0,
  class: "uf-events__close-item"
}
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "图片：", -1))
const _hoisted_98 = { class: "uf-events__close-content" }
const _hoisted_99 = { class: "uf-events__close-item" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "备注：", -1))
const _hoisted_101 = { class: "uf-events__close-content" }
const _hoisted_102 = {
  key: 5,
  class: "uf-events__close"
}
const _hoisted_103 = { class: "uf-events__close-item" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "审核人：", -1))
const _hoisted_105 = { class: "uf-events__close-content" }
const _hoisted_106 = { style: {"margin-left":"5px"} }
const _hoisted_107 = {
  key: 6,
  class: "uf-button"
}
const _hoisted_108 = { class: "uf-button--footer" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fff"} }, "加载中...", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_tag = _resolveComponent("van-tag")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_approval = _resolveComponent("approval")!
  const _component_remarks = _resolveComponent("remarks")!
  const _component_van_empty = _resolveComponent("van-empty")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_van_cell, {
              class: "uf-approvalDetail__cell",
              border: false,
              title: `报警状态：${_ctx.fire_state_name}`
            }, null, 8, ["title"]),
            (_ctx.event_log.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "uf-approvalDetail__header__bottom",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (
          _ctx.$router.push({
            name: _ctx.$RouterName.FIRE_LOG,
            params: {
              id: _ctx.id
            }
          })
        ))
                }, [
                  _createVNode(_component_van_cell, {
                    center: "",
                    "is-link": ""
                  }, {
                    title: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("i", null, _toDisplayString(_ctx.moment("20" + _ctx.event_log[0].opt_time_name).format("HH:mm")), 1),
                          _createElementVNode("b", null, _toDisplayString(_ctx.moment("20" + _ctx.event_log[0].opt_time_name).format("YY-MM-DD")), 1)
                        ]),
                        _hoisted_5,
                        _createElementVNode("div", _hoisted_6, [
                          (_ctx.event_log[0].opt_uid_array[0]?.department_name)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_7, _toDisplayString(_ctx.event_log[0].opt_uid_array[0]?.department_name) + " - " + _toDisplayString(_ctx.event_log[0].opt_uid_array[0]?.name), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("b", null, _toDisplayString(_ctx.event_log[0].show_content), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createTextVNode(_toDisplayString(_ctx.fire_type_name) + " ", 1),
              (_ctx.is_overtime == '1')
                ? (_openBlock(), _createBlock(_component_van_tag, {
                    key: 0,
                    style: {"margin-left":"5px"},
                    color: "#FF5B34",
                    plain: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.is_overtime_name), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", null, _toDisplayString(_ctx.fire_code), 1)
            ]),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.fire_time_name), 1)
          ]),
          (_ctx.fire_parts_lists.length === 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.fire_parts_lists[0].code), 1)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.fire_parts_lists[0].name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.fire_parts_lists[0].parts_type_id_name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.fire_parts_lists[0].true_place_name), 1)
                  ])
                ])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_26, "报警记录（共" + _toDisplayString(_ctx.fire_parts_lists.length) + "条）", 1),
                _createElementVNode("div", _hoisted_27, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fire_parts_lists, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: item.id
                    }, [
                      (index < 5 || _ctx.fireListShow)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _hoisted_30,
                              _createElementVNode("div", _hoisted_31, _toDisplayString(item.code), 1)
                            ]),
                            _createElementVNode("div", _hoisted_32, [
                              _hoisted_33,
                              _createElementVNode("div", _hoisted_34, _toDisplayString(item.parts_type_id_name), 1)
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              _hoisted_36,
                              _createElementVNode("div", _hoisted_37, _toDisplayString(item.true_place_name), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128)),
                  (!_ctx.fireListShow && _ctx.fire_parts_lists.length > 5)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "more",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fireListShow = true))
                      }, " 查看更多 "))
                    : _createCommentVNode("", true)
                ])
              ], 64)),
          (Object.keys(_ctx.handler).length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _hoisted_38,
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createElementVNode("div", _hoisted_42, [
                      (_ctx.handler.handler_uid_array.length > 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.handler.handler_uid_array[0].department_name) + " - " + _toDisplayString(_ctx.handler.handler_uid_array[0].name), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock("i", _hoisted_43, "-"))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _hoisted_45,
                    _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.handler.receive_time_name || "-"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _hoisted_48,
                    _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.handler.receive_time_consuming || "-"), 1)
                  ]),
                  (_ctx.handler.operation_lists.length > 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_50,
                        _createElementVNode("div", _hoisted_51, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.handler.operation_lists, (operation, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "operation-list__item",
                              key: index
                            }, [
                              (operation.type == 1)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("div", _hoisted_52, " 转工单 " + _toDisplayString(operation.fault_time_name), 1),
                                    _createElementVNode("div", {
                                      class: "item-content",
                                      onClick: ($event: any) => (_ctx.toOperationDetail(1, operation.id))
                                    }, [
                                      _createVNode(_component_van_image, {
                                        width: "40",
                                        height: "40",
                                        src: require('../../assets/icons/icon_repair.png')
                                      }, null, 8, ["src"]),
                                      _createElementVNode("div", _hoisted_54, [
                                        _createElementVNode("div", _hoisted_55, _toDisplayString(operation.orderid), 1),
                                        _createElementVNode("div", _hoisted_56, _toDisplayString(operation.faulttype_name), 1)
                                      ]),
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["item-content__button", {
                      yellow: operation.repairstate_name == '待接单'
                    }])
                                      }, _toDisplayString(operation.repairstate_name), 3)
                                    ], 8, _hoisted_53)
                                  ], 64))
                                : _createCommentVNode("", true),
                              (operation.type == 2)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("div", _hoisted_57, " 转审批 " + _toDisplayString(operation.create_time_name), 1),
                                    _createElementVNode("div", {
                                      class: "item-content",
                                      onClick: ($event: any) => (_ctx.toOperationDetail(2, operation.id))
                                    }, [
                                      _createVNode(_component_van_image, {
                                        width: "40",
                                        height: "40",
                                        src: operation.icon
                                      }, null, 8, ["src"]),
                                      _createElementVNode("div", _hoisted_59, [
                                        _createElementVNode("div", _hoisted_60, _toDisplayString(operation.code), 1),
                                        _createElementVNode("div", _hoisted_61, _toDisplayString(operation.name), 1)
                                      ]),
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["item-content__button", {
                      orange: operation.state_name == '审批中'
                    }])
                                      }, _toDisplayString(operation.state_name), 3)
                                    ], 8, _hoisted_58)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.close.close_time_name)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _hoisted_62,
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _hoisted_65,
                    _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.close.close_time_name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    _hoisted_68,
                    _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.close.close_time_consuming), 1)
                  ]),
                  _createElementVNode("div", _hoisted_70, [
                    _hoisted_71,
                    _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.close.close_result_name), 1)
                  ]),
                  (_ctx.close.fire_alarm_name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                        _hoisted_74,
                        _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.close.fire_alarm_name), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.close.fire_linkage_name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                        _hoisted_77,
                        _createElementVNode("div", _hoisted_78, _toDisplayString(_ctx.close.fire_linkage_name), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.close.pic_ids_lists?.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                        _hoisted_80,
                        _createElementVNode("div", _hoisted_81, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.close.pic_ids_lists, (photo) => {
                            return (_openBlock(), _createBlock(_component_van_image, {
                              key: photo.id,
                              style: {"margin-right":"10px"},
                              width: "105px",
                              height: "90px",
                              fit: "cover",
                              src: photo.photo_thumb_file,
                              onClick: ($event: any) => (_ctx.ImagePreview([photo.photo_file]))
                            }, null, 8, ["src", "onClick"]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_82, [
                    _hoisted_83,
                    _createElementVNode("div", _hoisted_84, _toDisplayString(_ctx.close.opt_content || "-"), 1)
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.close.copy_lists?.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                _hoisted_86,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.close.copy_lists, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "uf-copy__item",
                    key: item.opt_uid
                  }, [
                    _createElementVNode("div", _hoisted_87, [
                      _hoisted_88,
                      _createElementVNode("div", _hoisted_89, _toDisplayString(item.opt_uid_array[0] ? item.opt_uid_array[0].name : "-"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_90, [
                      _hoisted_91,
                      _createElementVNode("div", _hoisted_92, _toDisplayString(item.opt_time_name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_93, [
                      _hoisted_94,
                      _createElementVNode("div", _hoisted_95, _toDisplayString(item.close_result_name), 1)
                    ]),
                    (item.pic_ids_array.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                          _hoisted_97,
                          _createElementVNode("div", _hoisted_98, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.pic_ids_array, (photo) => {
                              return (_openBlock(), _createBlock(_component_van_image, {
                                key: photo.id,
                                style: {"margin-right":"10px"},
                                width: "105px",
                                height: "90px",
                                fit: "cover",
                                src: photo.photo_thumb_file,
                                onClick: ($event: any) => (_ctx.ImagePreview([photo.photo_file]))
                              }, null, 8, ["src", "onClick"]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_99, [
                      _hoisted_100,
                      _createElementVNode("div", _hoisted_101, _toDisplayString(item.opt_content), 1)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.approvalList.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                _createElementVNode("div", _hoisted_103, [
                  _hoisted_104,
                  _createElementVNode("div", _hoisted_105, [
                    _createElementVNode("div", {
                      class: "approval-content",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.approvalState.show = true))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.approvalList, (approval, index) => {
                        return _withDirectives((_openBlock(), _createBlock(_component_van_image, {
                          key: approval.id,
                          round: "",
                          width: "24px",
                          height: "24px",
                          style: _normalizeStyle({ marginLeft: index > 0 ? '-6px' : '0px' }),
                          src: approval.head_pic
                        }, null, 8, ["style", "src"])), [
                          [_vShow, index < 6]
                        ])
                      }), 128)),
                      _createTextVNode(" ... "),
                      _createElementVNode("div", _hoisted_106, "共" + _toDisplayString(_ctx.approvalList.length) + "人", 1),
                      _createVNode(_component_van_icon, {
                        name: "arrow",
                        color: "#999999",
                        size: "14",
                        style: {"margin-left":"auto"}
                      })
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.innerOptLists.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                _createElementVNode("div", _hoisted_108, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.innerOptLists, (button) => {
                    return (_openBlock(), _createBlock(_component_van_button, {
                      key: button.button_key,
                      class: "btn",
                      block: "",
                      color: "#3d6eeb",
                      square: "",
                      type: "success",
                      onClick: ($event: any) => (_ctx.buttonClick(button.button_key))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(button.button_name), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_approval, {
      show: _ctx.approvalState.show,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.approvalState.show) = $event)),
      list: _ctx.approvalList
    }, null, 8, ["show", "list"]),
    (_ctx.id)
      ? (_openBlock(), _createBlock(_component_remarks, {
          key: 1,
          show: _ctx.remarkState.show,
          "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.remarkState.show) = $event)),
          onSubmit: _ctx.remarkState.submit
        }, null, 8, ["show", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.showLock)
      ? (_openBlock(), _createBlock(_component_van_empty, {
          key: 2,
          class: "custom-image",
          image: require('@/assets/icon_lock.png'),
          description: "暂无查看权限"
        }, null, 8, ["image"]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_overlay, { show: _ctx.overlayShow }, {
      default: _withCtx(() => [
        _createVNode(_component_van_loading, {
          size: "24px",
          vertical: "",
          color: "#ffffff",
          style: {"color":"#fff"}
        }, {
          default: _withCtx(() => [
            _hoisted_109
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}